module.exports = __webpack_public_path__ + "static/media/mp3-icon.1e2155dc.svg";